import { createContext, useContext, useEffect, useState } from "react";

const STATES = [
  { code: "TX", label: "Texas (Medical + Hemp)", type: "medical" },
  { code: "CO", label: "Colorado (Recreational)", type: "recreational" },
  { code: "CA", label: "California (Recreational)", type: "recreational" },
  { code: "NV", label: "Nevada (Recreational)", type: "recreational" },
  { code: "ALL", label: "All States (Demo)", type: "demo" },
];

const CtxState = createContext(null);

export function StateProvider({ children }) {
  const [stateCode, setStateCode] = useState(() => localStorage.getItem("xseed_state") || "TX");
  useEffect(() => { localStorage.setItem("xseed_state", stateCode); }, [stateCode]);
  const current = STATES.find((s) => s.code === stateCode) || STATES[0];
  return (
    <CtxState.Provider value={{ stateCode, setStateCode, current, options: STATES }}>
      {children}
    </CtxState.Provider>
  );
}

export const useStateCtx = () => useContext(CtxState);
